import { styled, Typography, Box } from '@mui/material';
import { theme } from 'assets/themes/zizzi';

const stepRadius = theme.radius.sm;
const countColor = theme.palette.white;
const countBgColor = theme.palette.primary.main;
const textBgColor = theme.palette.neutral.light;

export const Step = styled(Box)`
  border-radius: ${stepRadius};
  display: flex;
  height: 100%;
  min-height: 52px;
  overflow: hidden;
`;

export const Count = styled(Box)`
  align-items: center;
  background: ${countBgColor};
  color: ${countColor};
  display: flex;
  font-size: 20px;
  font-weight: bold;
  justify-content: center;
  width: 35px;
`;

export const Text = styled(Typography)`
  align-items: center;
  background: ${textBgColor};
  display: flex;
  flex: 1;
  line-height: 18px;
  padding: 0.25rem 0.75rem 0.5rem 0.75rem;
`;
